import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateConfig,
  getDrumBallRecheckListData,
} from "../../../store/slices/DrumBall/drumBallSlice";
import { debounce } from "../../../utils/hooks/useDebounce";

const useDrumBallRecheck = () => {
  const [pendingPage, setPendingPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [gliNumber, setGliNumber] = useState("");
  const [activeCard, setActiveCard] = useState({ id: "", key: "" });

  const drumBallState = useSelector((state) => state.drumBall);
  const drumBallData = drumBallState.drumBallRecheckData;

  const dispatch = useDispatch();
  const slug = sessionStorage?.getItem("slug");

  useEffect(() => {
    const params = {
      page: pendingPage,
      per_page: drumBallState.certificate.currentPageSize,
      process_slug: slug,
    };
    dispatch(getDrumBallRecheckListData(params));
    // eslint-disable-next-line
  }, [pendingPage, drumBallState.certificate.currentPageSize, slug]);

  const triggerSearch = (searchValue) => {
    dispatch(
      updateConfig((state) => {
        state.drumBallRecheckData.Pending = [];
      }),
    );
    const params = {
      page: 1,
      per_page: drumBallState.certificate.currentPageSize,
      search: searchValue,
      process_slug: slug,
    };
    dispatch(getDrumBallRecheckListData(params));
  };

  const debouncedSearch = useMemo(
    () => debounce((searchValue) => triggerSearch(searchValue), 500),
    // eslint-disable-next-line
    [slug, drumBallState.certificate.currentPageSize],
  );

  const handleSearchInput = (e) => {
    const searchValue = e.target.value;
    dispatch(updateConfig((state) => (state.search = searchValue)));
    debouncedSearch(searchValue);
  };

  const handleSearch = () => {
    triggerSearch(drumBallState?.search);
  };

  const handleChange = (item) => {
    dispatch(
      updateConfig((state) => {
        state.selectedCardId = item?._id;
        state.certificate.search = "";
        state.certificate.currentPage = 1;
      }),
    );
    setGliNumber(item?.gli_number);
    setActiveCard({ id: item?._id, key: "Pending" });
    setShowDetail(true);
  };

  const handleLoadMore = (mouseHover) => {
    if (
      mouseHover === "Pending" &&
      drumBallData?.Pending?.length !== drumBallState?.total?.Pending
    ) {
      setPendingPage(pendingPage + 1);
    }
  };

  return {
    gliNumber,
    showDetail,
    activeCard,
    drumBallData,
    isLoading,
    totalLength: {
      Pending: drumBallState?.total?.Pending,
    },
    apiStatus: {
      Pending: drumBallState?.drumBallRecheckDataStatus,
    },
    handleSearch,
    handleSearchInput,
    handleLoadMore,
    handleChange,
    setIsLoading,
  };
};

export default useDrumBallRecheck;
